module.exports = __webpack_public_path__ + "static/media/crash.e846a8aa.ogg";